// ? Localhost mode enable
const isEnableLocalhost = import.meta.env.VITE_APP_MODE === "development";
const localhostUri = "https://pe.8byte.ai";
const Configuration = {
  baseUrl: isEnableLocalhost ? localhostUri : import.meta.env.VITE_NODE_URL,
};

export default Configuration;
